(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$GP"));
	else if(typeof define === 'function' && define.amd)
		define(["$GP"], factory);
	else if(typeof exports === 'object')
		exports["__NAMESPACE__/__NAME__@__VERSION__index"] = factory(require("$GP"));
	else
		root["__NAMESPACE__/__NAME__@__VERSION__index"] = factory(root["$GP"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_76__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition